import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["type", "name", "id", "placeholder", "label", "className", "dataHook", "onValidate", "onBlur"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import Input from '@segment/matcha/components/Input';
import formRegex from '@segment/utils/regexes/form';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var jobTitleMessages = {
  required: "Please provide your job title.",
  invalid: "Please provide a valid job title."
};
export var JobTitleField = function JobTitleField(_ref) {
  var _errors$name;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "jobTitle" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "jobTitle" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Job title" : _ref$placeholder,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "What is your job title?" : _ref$label,
      className = _ref.className,
      dataHook = _ref.dataHook,
      onValidate = _ref.onValidate,
      _onBlur = _ref.onBlur,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useFormContext = useFormContext(),
      register = _useFormContext.register,
      trigger = _useFormContext.trigger,
      setError = _useFormContext.setError,
      errors = _useFormContext.formState.errors;

  var _useState = useState(false),
      valid = _useState[0],
      setValid = _useState[1];

  var _useState2 = useState(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var handleValidation = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
      var jobTitleValue, validatorResponse, isResponseValid, validator;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              jobTitleValue = value.trim();
              validatorResponse = {
                valid: true,
                message: ""
              };
              isResponseValid = formRegex.test(jobTitleValue);

              if (!(typeof onValidate === "function")) {
                _context.next = 12;
                break;
              }

              setIsLoading(true);
              _context.next = 7;
              return onValidate(jobTitleValue);

            case 7:
              validator = _context.sent;
              validatorResponse.valid = validator.valid;
              validatorResponse.message = validator.message;
              isResponseValid = validatorResponse.valid;
              setIsLoading(false);

            case 12:
              setValid(isResponseValid);

              if (!isResponseValid) {
                setError(name, {
                  type: "validate",
                  message: validatorResponse.message
                });
              }

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [onValidate]);
  return _jsx(Input, _objectSpread(_objectSpread({
    className: className,
    id: id,
    placeholder: placeholder,
    label: label,
    type: type,
    "aria-label": placeholder,
    error: Boolean(errors[name]),
    showValidState: valid && Boolean(!errors[name]),
    errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    expanded: true,
    "data-hook": dataHook,
    onAutoFill: function onAutoFill(value) {
      setValid(formRegex.test(value));
      trigger(name);
    },
    isLoading: isLoading
  }, register(name, {
    required: jobTitleMessages.required,
    pattern: {
      value: formRegex,
      message: jobTitleMessages.invalid
    },
    onBlur: function onBlur(e) {
      trigger(name);
      handleValidation(e.target.value);
      if (_onBlur && !valid && Object.hasOwn(errors, name)) _onBlur(errors);
    }
  })), rest));
};
export default JobTitleField;